import { Component, AfterViewInit } from '@angular/core';
import { EventsService } from 'src/app/services/event/event.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { RoutingService } from 'src/app/services/routing/routing.service';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
    selector: 'app-close-account',
    templateUrl: './close-account.component.html',
    styleUrls: ['./close-account.component.scss'],
})
export class CloseAccountComponent implements AfterViewInit {

    error = null;
    public accountClosed: boolean = false;
    public labels: SiteContentInterface;

    constructor(
        private events: EventsService,
        private logoutService: LogoutService,
        private navigator: Navigator,
        private responsibleGamingProvider: ResponsibleGamingService,
        private siteContentService: SiteContentService,
        private routing: RoutingService,
    ) {
        this.labels = new SiteContentModel();
    }

    ngAfterViewInit() {
        this.siteContentService.loadConfig('close_account')
            .then((response: SiteContentInterface) => {
                this.labels = response
            })
    }

    public onCloseAccount() {
        this.responsibleGamingProvider.callCloseAccount().subscribe({
            next: (response) => {
                if (response.result == 1) {
                    setTimeout(() => {
                        this.events.publish("event:close:account", {});
                        this.routing.defaultRoute();
                        this.logoutService.callLogout({ code: 'PLAYER_CLOSE_ACCOUNT' })
                        //   this.navigator.navigateTo("LogoutPage", {}, {reason:'PLAYER_CLOSE_ACCOUNT'});
                    }, 1000);

                    this.accountClosed = true;
                }
            },
            error: (error) => {
                this.error = error;
            }
        });
    }
}
